<header class="h-[60px] border-t-4 border-[#900027] bg-[#f4f4f4] flex items-center">
  <nav class="flex justify-between flex-1 px-4">
    <a class="h-10 flex justify-center" routerLink="/">
      <img src="img/logo.svg" alt="Victorinox logo" class="w-auto h-full" />
    </a>

    <div class="flex gap-4 justify-end items-center flex-1">
      <select
        class="uppercase bg-[#f4f4f4] border-4 border-transparent focus:border-[#90002740] rounded-md px-3 py-1.5 cursor-pointer outline-none transition-colors"
        [(ngModel)]="currentLanguage"
        (ngModelChange)="changeLanguage()"
      >
        @for (lang of languages; track $index) {
          <option [ngValue]="lang">{{ lang }}</option>
        }
      </select>

      <div class="relative">
        <button
          (click)="isDropdownOpen.set(!isDropdownOpen())"
          class="flex items-center gap-2 px-3 py-1.5 rounded-md border-4 border-transparent focus:border-[#90002740] transition-colors"
        >
          <i class="fas fa-user"></i>
          <span class="font-medium">{{ username() }}</span>
          <i class="fas fa-caret-down ml-1"></i>
        </button>

        @if (isDropdownOpen()) {
          <div
            class="absolute right-0 w-full min-w-[140px] bg-white border border-gray-200 shadow-lg rounded z-50 py-1">
            <button
              (click)="logout()"
              class="w-full text-left px-4 py-2 hover:bg-gray-100 transition-colors"
            >
              Logout
            </button>
          </div>
        }
      </div>
    </div>
  </nav>
</header>
